module.exports = __webpack_public_path__ + "static/news9-1-159c83ad12a030c3233ea4dcc5657ba3.jpg";